import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';
import { FormBuilder,FormGroup,FormControl, FormArray,Validators, ValidatorFn } from "@angular/forms";
import { Router } from "@angular/router";
import { ValidationService } from 'src/app/validation.service';



@Component({
  selector: 'app-sign-up-user',
  templateUrl: './sign-up-user.component.html',
  styleUrls: ['./sign-up-user.component.css']
})
export class SignUpUserComponent implements OnInit {

submitted:any;
formAdmin: any;
userData:any;
registerForm: FormGroup;
  constructor(
    public authService: AuthService,
    public router: Router, 
	private fb: FormBuilder,
	private validate: ValidationService
  ) 
  
  { 
	this.registerForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
	  telefono: [''],
      email2:['', [Validators.required, Validators.email]],
	  password: ['', Validators.compose([Validators.required, this.validate.patternValidator()])],
	  confirmPassword: ['', [Validators.required]],
	  proyecto:['friatNefrosoft'],
	  status:[true]

    },
	
	{
        validator: this.validate.MatchPassword('password', 'confirmPassword'),
      }
	
	
	)
  }
  
  ngOnInit() { }

  get registerFormControl() {
    return this.registerForm.controls;
  }

  onSubmit(dataUser:any){
    console.log(dataUser);

	this.submitted = true;
  
    dataUser.rol = "user";

    this.authService.postRegistro(dataUser)
        .subscribe (res=>{
          if (res) {
            this.userData = res;
            localStorage.setItem('sfeJfsld8dsKld5lRld', this.userData.token);
            this.router.navigate(['dashboard']);
            //JSON.parse(localStorage.getItem('sfeJfsld8dsKld5lRld'));
          } else {
            localStorage.setItem('sfeJfsld8dsKld5lRld', "null");
            //JSON.parse(localStorage.getItem('sfeJfsld8dsKld5lRld'));
          }
        });   
  }

  
 
}
